import { useEffect } from "react";
import { CirclePlus } from "lucide-react";
import ArrayInputCard from "./Card";

const ArrayCardsGroup = ({ 
    register, 
    errors, 
    setValue, 
    watch,
    groupName,
    fields,
    fieldTitle,
    userCanAdd = true
}) => {
    const watchItems = watch(groupName) || [];

    // 初始化
    useEffect(() => {
        if (watchItems.length === 0) {
            const initialItem = {
                ...fields.reduce((acc, field) => {
                    if (field.type === 'array') {
                        acc[field.name] = [''];  // 陣列類型初始化為包含一個空字串
                    } else {
                        acc[field.name] = '';
                    }
                    return acc;
                }, {}),
                uuid: Date.now()
            };
            setValue(groupName, [initialItem]);
        }
    }, []);

    // 添加新卡片
    const addItem = () => {
        const newItem = {
            ...fields.reduce((acc, field) => {
                if (field.type === 'array') {
                    acc[field.name] = [''];
                } else {
                    acc[field.name] = '';
                }
                return acc;
            }, {}),
            uuid: Date.now()
        };
        setValue(groupName, [...watchItems, newItem]);
    };

    // 移除卡片
    const removeItem = (index) => {
        const newItems = watchItems.filter((_, i) => i !== index);
        setValue(groupName, newItems);
    };

    return (
        <div className="space-y-6">
            {Array.isArray(watchItems) && watchItems.map((item, index) => (
                <ArrayInputCard
                    key={item.uuid || `${groupName}-${index}`}
                    index={index}
                    fields={fields}
                    register={register}
                    errors={errors}
                    watch={watch}
                    setValue={setValue}
                    onRemove={() => removeItem(index)}
                    groupName={groupName}
                />
            ))}
            
            {userCanAdd && (
                <button
                    type="button"
                    onClick={addItem}
                    className="my-4 p-2 w-fit flex flex-col items-center justify-center text-gray-500 hover:text-gray-700 hover:border-gray-400"
                >
                    <CirclePlus size={32} strokeWidth={1} />
                    <span className="mt-1 text-sm">新增</span>
                </button>
            )}
        </div>
    );
};

export default ArrayCardsGroup;